export default "__VITE_ASSET__1a7d63f1__"